/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconStatusReport = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      viewBox="0 0 24 24"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 24px;
      `}
      {...props}
    >
      <g
        fill={fill}
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={weight === "normal" ? 1.5 : 1}
      >
        <path d="M17.033 16.583l-4.492 4.686a.749.749 0 0 1-1.059.023l-.023-.023-4.493-4.687M1.471 10.587a5.674 5.674 0 0 1-.122-5.3h0a5.672 5.672 0 0 1 9.085-1.474L12 5.374l1.566-1.566a5.674 5.674 0 0 1 9.085 1.474h0a5.68 5.68 0 0 1-.119 5.3" />
        <path d="M.75 13.583h6.518c.142 0 .272-.08.336-.207l1.723-3.447a.376.376 0 0 1 .7.06l1.681 5.6a.375.375 0 0 0 .7.04l1.57-3.664a.376.376 0 0 1 .657-.061l1.116 1.674h7.5" />
      </g>
    </svg>
  ),
);
